$(function(){
  // chosen generico
  if($('.chzn-select').length > 0){
  	$('.chzn-select').chosen({
      no_results_text: 'Nessun Risultato Trovato per: ',
      width: '100%'
  	});
  }

  if($('.role-select').length > 0){
    $('.role-select').chosen({width: '368px', placeholder_text: 'Seleziona Ruolo'});
  }
});
